import React from "react";
import StudentMessages from "components/students/Messages";
// import AdminStartupMessages from "components/adminStartup/Messages";
import RBACSwitcher from "components/common/Auth/RBACSwitcher";
import TeacherMessages from "../components/teachers/Messages";

const Messages = () => {
  return (
    <RBACSwitcher
      student={<StudentMessages />}
      teacher={<TeacherMessages />}
      school={<div>Msg Admin ecoles</div>}
    />
  );
};

export default Messages;
